module.exports = __webpack_public_path__ + "assets/img/announcement1.1.d156b004.png";